import { focusAnchor } from "@/lib/anchor-focus";

/**
 * Visually hidden until focused, then anchored below the sticky header.
 * Uses the shared anchor helper so scrolling honors prefers-reduced-motion
 * and keyboard focus lands on <main> exactly like other in-page jumps.
 */
export function SkipToContent() {
  return (
    <a
      href="#main-content"
      onClick={(event) => {
        // Keep the hash in the URL (so back/forward restore works) but take
        // over the jump for smooth, offset-aware scrolling plus focus.
        if (focusAnchor("#main-content")) {
          event.preventDefault();
          if (window.location.hash !== "#main-content") {
            window.history.replaceState(window.history.state, "", "#main-content");
          }
        }
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:inline-flex focus:min-h-11 focus:items-center focus:rounded-md focus:bg-brand-logo focus:px-4 focus:py-2 focus:text-base focus:font-medium focus:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}
